"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsClient = void 0;
const service_client_lib_1 = require("@manifoldxyz/service-client-lib");
class SubscriptionsClient extends service_client_lib_1.BaseClient {
    constructor({ baseUrl, getHeaders, defaultTimeout, getDefaultQueryParams, }) {
        super({
            baseUrl,
            defaultTimeout,
            getDefaultQueryParams,
            getHeaders,
        });
    }
    /**
     * For getting the information related to a single subscription to a creator wallet.
     *
     * @param walletAddress | wallet address of the creator the subscriber is sub'd to
     * @param token | encrypted token to gain access to server, contains subscriber email info
     * @returns | the subscription object
     */
    getSubscription(walletAddress, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.get(`/subscription/${walletAddress}?token=${token}`);
            }
            catch (error) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (error.response.status === 404) {
                    return undefined;
                }
                throw new Error('Failed to get subscriber');
            }
        });
    }
    /**
     * For getting all subscriptions for a creator wallet.
     *
     * @param walletAddress | wallet address of the creator
     * @returns | an array of subscription objects
     */
    getAllSubscriptionsForCreator() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.get(`/subscribers/all`);
            }
            catch (error) {
                throw new Error('Failed to get subscriptions');
            }
        });
    }
    /**
     * For getting all subscriptions to creator wallets for a single email subscriber.
     *
     * @param token | encrypted token to gain access to server, contains subscriber email info
     * @returns all subscriptions for a subscriber
     */
    getAllSubscriptionsForSubscriber(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.get(`/subscriptions?token=${token}`);
            }
            catch (error) {
                throw new Error('Failed to get subscriptions');
            }
        });
    }
    /**
     * For updating the blocked topics of a single subscription to a creator's wallet.
     *
     * @param creatorWallet | wallet of the creator the subscriber is sub'd to
     * @param blockedTopics | topics to block
     * @param token | encrypted token to gain access to server, contains subscriber email info
     * @returns
     */
    updateSubscriptionTopics(creatorWallet, blockedTopics, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.put(`/subscriptions/${creatorWallet}`, {
                    data: { blockedTopics, token },
                });
            }
            catch (error) {
                throw new Error('Failed to add topics');
            }
        });
    }
    /**
     * For updating a batch of subscriptions that all
     * belong to the same subscriber email.
     *
     * @param subscriptions | an array of subscriptions to update
     * @param token | encrypted token to gain access to server, contains subscriber email info
     * @returns
     */
    updateSubscriptionsForSubscriber(subscriptions, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.put('/subscriptions', {
                    data: { subscriptions, token },
                });
            }
            catch (error) {
                throw new Error('Failed to update subscriptions');
            }
        });
    }
    subscribeToCreator(creatorAddress, subscriberEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.post(`/subscriptions/${creatorAddress}`, {
                    data: { subscriberEmail },
                });
            }
            catch (error) {
                throw new Error('Failed to subscribe to creator');
            }
        });
    }
    /**
     * For unsubscribing from a single creator.
     *
     * @param walletAddress | wallet address of the creator to unsubscribe from
     * @param token | encrypted token to gain access to server, contains subscriber email info
     */
    unsubscribeFromSubscription(walletAddress, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.delete(`/subscriptions/${walletAddress}?token=${token}`);
            }
            catch (error) {
                throw new Error('Failed to unsubscribe');
            }
        });
    }
}
exports.SubscriptionsClient = SubscriptionsClient;
//# sourceMappingURL=client.js.map